import {ChangeDetectorRef, Component, DestroyRef, inject, OnInit, viewChild, computed} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {map, Observable, startWith} from "rxjs";
import {ActivatedRoute, Router, RouterLink, RouterOutlet} from "@angular/router";
import {Tab, TabList, Tabs, TabsModule} from "primeng/tabs";
import {DividerModule} from "primeng/divider";
import {UserService} from "../../services/user.service";
import {getAllRouteData} from "../../utils";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {isDeferredMandatoryUserAwaitingPayment} from "../../model/user";

@Component({
  standalone: true,
  imports: [
    ButtonModule,
    TabsModule,
    Tabs,
    TabList,
    Tab,
    DividerModule,
    RouterLink,
    RouterOutlet
  ],
  templateUrl: './tabs-container.component.html',
  host: {class: 'fill-page'},
})
export class TabsContainerComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly tabs = viewChild.required(
    Tabs
  )

  constructor(private readonly activatedRoute: ActivatedRoute,
              private readonly router: Router,
              private readonly userService: UserService) {

  }

  ngOnInit() {
    this.router.events.pipe(
      startWith(null),
      takeUntilDestroyed(this.destroyRef),
      map(() => getAllRouteData(this.activatedRoute).tab ?? 'profile'),
    ).subscribe(
      tab => {
        this.tabs().updateValue(
          tab
        )
      }
    )
  }

  protected readonly user = this.userService.user;
  protected readonly disableLotteriesTab = computed(() => {
    const currentUser = this.user();

    return currentUser?.status === 'mandatory-flow'
      ? isDeferredMandatoryUserAwaitingPayment(currentUser)
      : false;
  });

  protected readonly activeTab$: Observable<string> = this.router.events.pipe(
    startWith(null),
    map(() => getAllRouteData(this.activatedRoute).tab ?? 'profile'),
  )
}
